import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Row, Col, Input, Select, InputNumber, Radio, DatePicker } from 'antd';
import MyMap from '~components/my-map';
import updatePayloadDetails from '~helpers/location';
import TagTextArea from '~components/tag-text-area';
import { locationType } from '~constants';
import { rankTypeOptions } from '~constants/property-field-options';
import { dayFormatType, moment } from '~helpers/day';

class DetailsForm extends React.Component {
  constructor(props) {
    super(props);

    this.latitude = 0;
    this.longitude = 0;
    this.state = {
      starCnExpire: props?.data?.starCn,
      starRowExpire: props?.data?.starRow,
    };
  }

  getLocationInitialValue = () => {
    if (this.props.type === 'City') {
      return this.props.data && this.props.data.country ? this.props.data.country.name : '';
    }
    return this.props.data && this.props.data.city ? this.props.data.city.name : '';
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { t } = this.props;
    const dateFormat = dayFormatType.UKFORMAT;

    if (this.latitude === 0 && this.longitude === 0 && this.props.data) {
      this.latitude = this.props.data.latitude;
      this.longitude = this.props.data.longitude;
    }

    return (
      <div
        className={classNames('details-form', this.props.className, {
          'details-form--city': this.props.type === 'City',
          'details-form--area': this.props.type === 'Area',
          'details-form--university': this.props.type === 'University',
        })}
      >
        <Form className="details-form__form">
          <Row gutter={24}>
            <Col span={24}>
              <If condition={this.props.type !== locationType.AREA_TYPE}>
                <div>
                  {getFieldDecorator('coordinates', {
                    initialValue: {
                      value: {
                        lat: this.latitude,
                        lng: this.longitude,
                      },
                      action: 'default',
                    },
                    trigger: 'onChange',
                  })(
                    <MyMap
                      t={this.props.t}
                      lastSearched={{
                        lat: this.props.data ? this.props.data.latitude : 0,
                        lng: this.props.data ? this.props.data.longitude : 0,
                      }}
                      form={this.props.form}
                      zoom={this.props.type === locationType.CITY_TYPE ? 8 : 14}
                      disabled={this.props.type === locationType.CITY_TYPE}
                      hiddenLabel={this.props.type === locationType.CITY_TYPE}
                      countryName={
                        this.props.data && this.props.data.country
                          ? this.props.data.country.name
                          : ''
                      }
                      cityName={
                        this.props.data && this.props.data.city ? this.props.data.city.name : ''
                      }
                      columnWidth={{ longitude: 8, latitude: 8, cityName: 8, countryName: 8 }}
                    />,
                  )}
                </div>
              </If>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                required
                label={t('cms.edit.details.label.name', {
                  type: this.props.type,
                })}
              >
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: this.props.t('cms.properties.edit.error.blank'),
                    },
                  ],
                  initialValue: this.props.data ? this.props.data.name : '',
                  validateTrigger: 'onBlur',
                })(<Input className="details-form__name-input" />)}
              </Form.Item>

              <Form.Item
                label={t(
                  `cms.edit.details.label.${this.props.type === 'City' ? 'country' : 'city'}`,
                )}
              >
                {getFieldDecorator('location', {
                  initialValue: this.getLocationInitialValue(),
                })(<Select className="details-form__select-location" disabled />)}
              </Form.Item>

              <If condition={this.props.type === 'University'}>
                <Form.Item label={t('cms.location.table.university.details.common_names')}>
                  {getFieldDecorator('commonNames', {
                    trigger: 'onChange',
                  })(
                    <TagTextArea
                      contentList={
                        this.props.data && this.props.data.commonNames
                          ? this.props.data.commonNames
                          : []
                      }
                      t={t}
                      countLimit={10}
                      tagLengthLimit={100}
                      placeholder={t(
                        'cms.location.table.university.details.common_names.placeholder',
                      )}
                      errorMessage={t('cms.edit.details.common_name.duplicated_message')}
                    />,
                  )}
                </Form.Item>
              </If>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('cms.edit.details.label.slug', {
                  type: this.props.type,
                })}
              >
                {getFieldDecorator('slug', {
                  initialValue: this.props.data ? this.props.data.slug : '',
                })(<Input className="details-form__slug-input" disabled />)}
              </Form.Item>

              <Form.Item required label={t('cms.edit.details.label.rank')}>
                {getFieldDecorator('rank', {
                  rules: [
                    { required: true, message: this.props.t('cms.properties.edit.error.blank') },
                  ],
                  initialValue: this.props.data ? Number(this.props.data.rank) : 0,
                  validateTrigger: 'onBlur',
                })(
                  <InputNumber
                    className="details-form__rank-input"
                    min={0}
                    max={1000}
                    placeholder="0~1000"
                  />,
                )}
              </Form.Item>

              <If condition={this.props.type === locationType.UNIVERSITY_TYPE}>
                <Form.Item>
                  <label className="details-form__label">
                    {t('cms.location.table.add_new.street_address')}
                  </label>
                  {getFieldDecorator('address', {
                    rules: [
                      {
                        required: true,
                        message: t('cms.properties.edit.error.blank'),
                      },
                    ],
                    initialValue: this.props.data && this.props.data.address,
                    trigger: 'onChange',
                  })(<Input className="details-form__name-input" />)}
                </Form.Item>
                <Form.Item>
                  <label className="details-form__label">
                    {t('cms.location.table.add_new.zip_code')}
                  </label>
                  {getFieldDecorator('zipCode', {
                    rules: [
                      {
                        required: true,
                        message: t('cms.properties.edit.error.blank'),
                      },
                    ],
                    initialValue: this.props.data && this.props.data.zipCode,
                    trigger: 'onChange',
                  })(<Input className="details-form__name-input" />)}
                </Form.Item>
              </If>
            </Col>
          </Row>

          <If condition={this.props.type === locationType.CITY_TYPE}>
            <section className="details-form__section">
              <h3 className="details-form__section__title">
                {t('cms.edit.details.section.rank_setting')}
              </h3>

              <Row gutter={24}>
                <Col span={12} className="details-form__column--gray-bg">
                  <div className="details-form__section__body">
                    <Form.Item label={t('cms.edit.details.label.rank_type.cn')}>
                      {getFieldDecorator('starCn', {
                        initialValue: this.props.data?.starCn,
                      })(
                        <RadioGroupWrap
                          t={t}
                          onChange={v =>
                            this.setState({
                              starCnExpire: v,
                            })
                          }
                        />,
                      )}
                    </Form.Item>

                    <If condition={this.state.starCnExpire}>
                      <Form.Item required label={t('cms.edit.details.label.expiration_date.cn')}>
                        {getFieldDecorator('starCnExpire', {
                          initialValue: this.props.data?.starCnExpire
                            ? moment(this.props.data?.starCnExpire)
                            : null,
                        })(<DatePicker style={{ width: '100%' }} format={dateFormat} />)}
                      </Form.Item>
                    </If>
                  </div>
                </Col>
                <Col span={12} className="details-form__column--gray-bg">
                  <div className="details-form__section__body">
                    <Form.Item label={t('cms.edit.details.label.rank_type.row')}>
                      {getFieldDecorator('starRow', {
                        initialValue: this.props.data?.starRow,
                      })(
                        <RadioGroupWrap
                          t={t}
                          onChange={v =>
                            this.setState({
                              starRowExpire: v,
                            })
                          }
                        />,
                      )}
                    </Form.Item>
                    <If condition={this.state.starRowExpire}>
                      <Form.Item required label={t('cms.edit.details.label.expiration_date.row')}>
                        {getFieldDecorator('starRowExpire', {
                          initialValue: this.props.data?.starRowExpire
                            ? moment(this.props.data?.starRowExpire)
                            : null,
                        })(<DatePicker style={{ width: '100%' }} format={dateFormat} />)}
                      </Form.Item>
                    </If>
                  </div>
                </Col>
              </Row>
            </section>
          </If>
        </Form>
      </div>
    );
  }
}

DetailsForm.propTypes = {
  t: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  form: PropTypes.object.isRequired,
  data: PropTypes.object,
};

DetailsForm.defaultProps = {
  t: () => {},
  className: '',
  type: 'University',
  data: null,
};

function RadioGroupWrap(props) {
  const { onChange, value, t } = props;
  return (
    <Radio.Group
      value={value ? 'STAR' : 'NORMAL'}
      onChange={e => {
        onChange(e.target.value === 'STAR');
      }}
    >
      <For each="option" of={rankTypeOptions.slice(0, 2)} index="key">
        <Radio value={option.value} key={key}>
          {t(option.text)}
        </Radio>
      </For>
    </Radio.Group>
  );
}

export default Form.create({
  name: 'details_form',
  onFieldsChange: (props, changedFields) => {
    let fields = changedFields;
    if (Object.keys(changedFields).includes('rank')) {
      fields.rank.value = Number(changedFields.rank.value);
    }

    if (Object.keys(changedFields).includes('coordinates')) {
      const coordinates = changedFields.coordinates;
      if (!coordinates.value || !coordinates.value.value) {
        return false;
      }
      delete fields.coordinates;
      fields = Object.assign({}, fields, {
        latitude: {
          value: coordinates.value.value.lat,
          errors:
            coordinates.value.value.lat === 0 &&
            coordinates.value.value.lng === 0 &&
            coordinates.value.action === 'default'
              ? 'error'
              : null,
          touched: true,
          name: 'latitude',
          dirty: coordinates.dirty,
        },
        longitude: {
          value: coordinates.value.value.lng,
          errors:
            coordinates.value.value.lat === 0 &&
            coordinates.value.value.lng === 0 &&
            coordinates.value.action === 'default'
              ? 'error'
              : null,
          touched: true,
          name: 'longitude',
          dirty: coordinates.dirty,
        },
      });
    }

    const result = updatePayloadDetails(props.data, props.type, fields, 'details');
    if (result) {
      props.setTabStatus(result);
    }

    return true;
  },
})(DetailsForm);
